export default "__VITE_ASSET__jdgXzX3a__"